import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
import { IEGridMixin } from './IEGridMixin';
var GRID_PROPERTIES = [
// Containers
'display', 'grid-template-columns', 'grid-template-rows', 'grid-template-areas', 'grid-template', 'column-gap', 'row-gap', 'gap', 'justify-items', 'align-items', 'place-items', 'justify-content', 'align-content', 'place-content', 'grid-auto-columns', 'grid-auto-rows', 'grid-auto-flow', 'grid',
// Containers (legacy)
'grid-column-gap', 'grid-row-gap', 'grid-gap',
// Items
'grid-column-start', 'grid-column-end', 'grid-row-start', 'grid-row-end', 'grid-column', 'grid-row', 'grid-area', 'justify-self', 'align-self', 'place-self', 'order'];
var gridCSS = function gridCSS(props) {
  var styles = [];
  Object.keys(props).forEach(function (prop) {
    var attr = prop.replace(/[A-Z]/g, function (char) {
      return "-" + char.toLowerCase();
    });
    if (GRID_PROPERTIES.indexOf(attr) >= 0) {
      styles.push(inlineMediaQueryMixin(prop, function (mediaProps) {
        var value = mediaProps[prop];
        if (/gap$/.test(attr)) {
          // Support values like `gap="sm xl"`
          value = value.split(/\s+/).map(function (v) {
            return spaceMixin(v)(mediaProps);
          }).join(' ');
        } else if (attr === 'grid-template-areas') {
          value = value.map(function (v) {
            return "\"" + v + "\"";
          }).join(' ');
        }
        return attr + ": " + value + ";";
      })(props));
    }
  });
  return styles;
};
export var GridMixin = function GridMixin(props) {
  return [IEGridMixin(props), gridCSS(props), spacingMixin(props)];
};